import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import reportWebVitals from './reportWebVitals';
import {createBrowserRouter, RouterProvider} from "react-router";
import Root from "./views/Root";
import LookupCustomerByAccountNumberView from "./views/LookupCustomerByAccountNumberView";
import {MsalProvider} from "@azure/msal-react";
import {EventType, EventMessage, Configuration, PublicClientApplication, AuthenticationResult} from "@azure/msal-browser"
import {authConfig} from "./authConfig";
import HomeSearchView from "./views/HomeSearchView";
import LookupCustomerByPhoneNumberView from "./views/LookupCustomerByPhoneNumberView";
import {AppProvider} from "@toolpad/core";

const router = createBrowserRouter([
    {
        path: "/",
        element: <Root/>,
        children: [
            {
                path: "/",
                element: <HomeSearchView/>
            },
            {
                path: "/lookupcustomeraccount",
                element: <LookupCustomerByAccountNumberView/>
            },
            {
                path: "/lookupcustomerphone",
                element: <LookupCustomerByPhoneNumberView/>
            }
        ]
    },

    ]);


const authenticationConfiguration = authConfig as Configuration;
const authenticationClient = new PublicClientApplication(authenticationConfiguration);

authenticationClient.initialize().then(() => {
    // Account selection logic is app dependent. Adjust as needed for different use cases.
    const accounts = authenticationClient.getAllAccounts();
    if (accounts.length > 0) {
        authenticationClient.setActiveAccount(accounts[0]);
    }

    console.log("Accounts", accounts[0]);

    authenticationClient.addEventCallback((event: EventMessage) => {
        if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
            const payload = event.payload as AuthenticationResult;
            const account = payload.account;
            authenticationClient.setActiveAccount(account);
            console.log("Successfully logged in, account", account);
        }
    });

    const root = ReactDOM.createRoot(
        document.getElementById('root') as HTMLElement
    );

    root.render(
        <React.StrictMode>
                <MsalProvider instance={authenticationClient}>
                        <RouterProvider router={router}/>
                </MsalProvider>
        </React.StrictMode>
    );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
